import { getWithToken } from 'api/network';

export async function GetSchools(lat, long, calcDistance) {
    // const url = `/api/ui/GetSchools?Latitude=${lat}&Longitude=${long}&CalcDistance=${calcDistance}`;
    const url = `/api/explore/GetSchools?Latitude=${lat}&Longitude=${long}&CalcDistance=${calcDistance}`;
    const response = await getWithToken(url);
    const data = await response.json();
    return data;
}